import { useEffect, useState } from "react";
import { auth } from "../firebase/firebase";
import { argosApiEntryPoint } from "../GlobalConfig";
import Chart from "react-google-charts";
import { CircularProgress } from "@mui/material";

interface PublisherOfInstitution {
    publisher: string,
    requestedArticlesNumber: number,
    lastPublication: string
}

interface InstitutionSummaryPublisherGraphProps {
    institutionId: string,
    mode: string
}

function InstitutionSummaryPublisherGraph({ institutionId, mode }: InstitutionSummaryPublisherGraphProps) {
    const [isLoading, setIsLoading] = useState(true)
    const [institutionalDashboardPublisherRetractions, setInstitutionalDashboardPublisherRetractions] = useState<any[][]>([]);

    const apiPath = (mode == 'retractions') ? "publisher-for-retractions" : "publisher-for-high-medium-risk"

    const publisherColumnHeaders: any[][] = [
        [
            { type: "string", label: "Publisher" },
            { type: "number", label: "Retractions" },
        ]
    ]

    useEffect(() => {

        setIsLoading(true)

        async function fetchData() {
            let authToken = await auth.currentUser?.getIdToken(true)

            fetch(argosApiEntryPoint + '/stats/institutional-summary/' + apiPath + '?institutionId=' + institutionId
                , {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json;charset=UTF-8',
                        'Authorization': 'Bearer ' + authToken
                    }
                })
                .then((response) => response.json())
                .then((data: PublisherOfInstitution[]) => {

                    let numericalSummaries: any[][] =
                        data.map(publisherStats =>
                            [
                                publisherStats.publisher,
                                publisherStats.requestedArticlesNumber
                                //isActive: isWithinLast12Months(journalStats.lastPublication)
                            ]
                        )
                    setInstitutionalDashboardPublisherRetractions(publisherColumnHeaders.concat(numericalSummaries.slice(0, 10)))
                    setIsLoading(false)
                }
                );
        }
        fetchData()
    }, [institutionId]);

    const publisherChartOptions = {
        legend: { position: 'none' },
        hAxis: {
            title: "Retractions",
            minValue: 0,
        },
        vAxis: {
            title: "Publisher",
        },
        height: 600,
        chartArea: {
            height: 1000,
        },
        //colors: ['#D33F00', '#FF3B30', '#FF9500']
    };

    return <>{isLoading && <CircularProgress />}
    {!isLoading &&
        <Chart
            chartType="BarChart"
            width="100%"
            data={institutionalDashboardPublisherRetractions}
            options={publisherChartOptions}
        />
    }</>;
}

export default InstitutionSummaryPublisherGraph